module.exports = __webpack_public_path__ + "img/share2.8bdce48a.jpg";